// extracted by mini-css-extract-plugin
export default {"wrapper":"DriverBreadcrumb_wrapper__yjeT+"};